package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.material3.FloatingActionButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme

/**
 * Floating action button (Stitch: saffron circle, bottom-end). [iconName] is a Material Symbols
 * ligature; [contentDescription] is the localized action label (required — a FAB is icon-only).
 */
@Composable
fun AppFab(
    iconName: String,
    contentDescription: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    FloatingActionButton(
        onClick = onClick,
        modifier = modifier,
        shape = AppTheme.shapes.pill,
        containerColor = AppTheme.colors.secondary,
        contentColor = AppTheme.colors.onSecondary,
    ) {
        AppIcon(
            name = iconName,
            size = AppTheme.sizes.iconLg,
            tint = AppTheme.colors.onSecondary,
            contentDescription = contentDescription,
        )
    }
}
